import { render, staticRenderFns } from "./schedule-reminder.vue?vue&type=template&id=2f4fbbaa&"
import script from "./schedule-reminder.vue?vue&type=script&lang=js&"
export * from "./schedule-reminder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports